import { StandardFullPageLayout } from "../../layouts/standard-full-page-layout.tsx";
import { FontStyles } from "../../utils/font-styles.ts";
import { ValuationsForm } from "./valuations-form.tsx";
import { CaptchaConfigProvider } from "../../utils/captcha/captcha-config-context.tsx";

export interface ValuationsFormPageProps {
  isLoggedIn: boolean;
}

export const ValuationsFormPage = ({ isLoggedIn }: ValuationsFormPageProps) => {
  return (
    <CaptchaConfigProvider>
      <StandardFullPageLayout maxWidthClassName="max-w-[900px]" verticalPadding={"py-7.5 md:py-15"}>
        <div className={"rounded-lg border border-solid border-foggy-firth relative"}>
          <div
            className={"h-[140px] xs:h-[260px] lg:h-[300px] rounded-t-lg overflow-hidden bg-cover bg-center"}
            style={{ backgroundImage: "url('/static/images/valuations-form-hero.webp')" }}
          >
            {/* ...image background... */}
          </div>
          {/* Floating label: static (below) on mobile, absolute top-right on md+ */}
          <div
            className={`bg-north-sea p-3.5 md:p-5 text-neutral-white top-0 static md:absolute md:right-6
                    ${FontStyles.h5} font-semibold leading-none md:leading-none`}
          >
            Home valuation request
          </div>

          {/* Page content placeholder */}
          <ValuationsForm isLoggedIn={isLoggedIn} />
        </div>
      </StandardFullPageLayout>
    </CaptchaConfigProvider>
  );
};
